<header class="ta:c">
  <h2 class="ttl-2">{{ title }}</h2>
</header>
